import axios from 'axios/dist/axios';


let AjaxHelperPlugin = {};

AjaxHelperPlugin.install = function (Vue, {router, store}) {

    let pluginData = {
        pendingRequestsCounter: 0,
        failedRequestsCounter: 0
    };


    let incrementPendingRequestsCounter = () => {
        pluginData.pendingRequestsCounter++;
    };
    let decrementPendingRequestsCounter = () => {
        pluginData.pendingRequestsCounter--;
    };

    let hasPendingRequests = () => {
        let hasRequests = (pluginData.pendingRequestsCounter > 0) ? true : false;
        return hasRequests;
    };
    let countPendingRequests = () => {
        return pluginData.pendingRequestsCounter > 0;
    };


    let incrementFailedRequestsCounter = () => {
        pluginData.failedRequestsCounter++;
    };

    let resetFailedRequestsCounter = () => {
        pluginData.failedRequestsCounter = 0;
    };

    let hasFailedRequests = () => {
        let hasFailedRequests = (pluginData.failedRequestsCounter > 0) ? true : false;
        return hasFailedRequests;
    };


    let initPendingRequestCounter = () => {
        // Add a request interceptor
        axios.interceptors.request.use(function (config) {
            incrementPendingRequestsCounter();
            return config;
        }, function (error) {
            return Promise.reject(error);
        });

        // Add a response interceptor
        axios.interceptors.response.use(function (response) {
            decrementPendingRequestsCounter();

            let currentRoute = router.history.current;

            if (typeof response.data.returnCode === "undefined" || (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0)) {
                return response;
            }
            else if (typeof response.data.returnCode !== "undefined" && (response.data.returnCode === 263 || response.data.returnCode === 264)) {
                // Vital Parameters errors are handled later (most likely by VitalParamsDropdownForm.vue).
                return response;
            }
            else if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 200) {
                // Expired session.
                store.commit("UserStore/resetStore");
                store.commit("TranslationStore/resetStore");
                // Go to Login page.
                router.push({ name: 'LoginPage', query: currentRoute.query}, () => {
                    // onComplete
                    window.location.reload(); // Reload Login page in order to refresh applicationData.
                });

                return Promise.reject("Expired session.");
            }
            else if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 100) {
                // Unauthorized access.
                store.commit("UserStore/resetStore");
                store.commit("TranslationStore/resetStore");

                if (router.currentRoute.name === "PF_HomePage" || router.currentRoute.name === "PF_ChatBotPage") {
                    sessionStorage.setItem('smass-home-route', router.currentRoute.name); // This will tell the app to immediately return back to current URL after user authentication. And it will help us with HOME button destination as well.
                }
                else if (router.currentRoute.path.indexOf("pathfinder/") < 0) {
                    sessionStorage.removeItem('smass-home-route');
                }

                // Go to Login page.
                router.push({ name: 'LoginPage', query: currentRoute.query}, () => {
                    // onComplete
                    window.location.reload(); // Reload Login page in order to refresh applicationData.
                });

                return Promise.reject("Unauthorized access.");
            }
            else if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 201) {
                // No assessment in progress.
                let sessionStorageHomeRouteName = sessionStorage.getItem("smass-home-route");
                if (sessionStorageHomeRouteName !== null && sessionStorageHomeRouteName === "PF_ChatBotPage") {
                    // PATHFINDER
                    router.push({name: 'PF_ChatBotPage'}).then(() => { // Go to Chatbot's home page (product list).
                        sessionStorage.removeItem("crtChatbotSection");
                        window.location.reload();
                    });
                }
                else {
                    // PRO
                    router.push({name: 'HomePage'}); // Go to PRO Home page (product list).
                }

                return Promise.reject("No assessment in progress.");
            }
            else {
                incrementFailedRequestsCounter();

                console.log("OUPS! A problem has been encountered on the server.");
                return Promise.reject({
                    errorMsg: "OUPS! A problem has been encountered on the server.",
                    serverResponse: response
                });
            }
        }, function (error) {
            decrementPendingRequestsCounter();
            incrementFailedRequestsCounter();

            console.error("ERROR! Server request failed.");
            return Promise.reject(error);
        });
    };

    initPendingRequestCounter();

    // ==================================
    // Export
    // ==================================

    Vue.AjaxHelper = {
        hasPendingAjaxRequests: hasPendingRequests,
        countPendingAjaxRequests: countPendingRequests,
        hasFailedRequests: hasFailedRequests,
        resetFailedRequestsCounter: resetFailedRequestsCounter
    };

    // Globally set a computed property so we can use {{ hasPendingAjaxRequests() }} in templates without re-declaring in each component.
    Vue.mixin({
        computed: {
            hasPendingAjaxRequests: () => hasPendingRequests
        }
    });

    // Export as instance method. Needed for usage in Vuex stores.
    Vue.prototype.$hasPendingAjaxRequests = hasPendingRequests;

};

export default AjaxHelperPlugin;



// WEBPACK FOOTER //
// ./src/common/plugins/AjaxHelperPlugin.js